"use client"

import Image from "next/image"
import { Button } from "@ui/shad"
import { X } from "lucide-react"

import { isAllBooksId } from "@/lib/all-books"
import { useFetchFeatureFlags } from "@/hooks/api/feature-flags/queries"
import { useFetchCurrentUser, useUpdateCurrentUser } from "@/hooks/api/users"
import { useBookId } from "@/hooks/use-book-id"
import { useLoadingRouter } from "@/hooks/use-loading-router"

export function SlantaIntroductionBanner() {
  const { data: currentUser } = useFetchCurrentUser()
  const updateUser = useUpdateCurrentUser()
  const bookId = useBookId()
  const router = useLoadingRouter()
  const { data: featureFlags } = useFetchFeatureFlags()

  if (
    !featureFlags ||
    featureFlags.includes("slanta_disabled") ||
    !currentUser ||
    currentUser.slanta_introduction_dismissed_at ||
    !bookId ||
    isAllBooksId(bookId)
  ) {
    return null
  }

  function dismiss(openGifts = false) {
    updateUser.mutate(
      { slanta_introduction_dismissed_at: new Date().toISOString() },
      {
        onSuccess: () => {
          if (openGifts) router.push("/slanta")
        },
      }
    )
  }

  return (
    <section
      aria-label="Introducing Slanta Claus"
      className="bg-green-background border-green-border flex shrink-0 flex-wrap items-center justify-between gap-3 border-b px-4 py-3"
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <Image
          src="/slanta/slant-santa-hat.png"
          alt=""
          width={40}
          height={40}
          className="size-10 shrink-0 object-contain"
        />
        <div>
          <p className="text-sm font-semibold">Introducing Slanta Claus</p>
          <p className="text-muted-foreground text-sm">
            Send clients holiday gifts with a personal card. We handle the shipping. Find Slanta anytime using the Santa
            hat in the top right.
          </p>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" variant="primary" disabled={updateUser.isPending} onClick={() => dismiss(true)}>
          Explore gifts
        </Button>
        <Button
          size="iconSm"
          variant="ghost"
          aria-label="Dismiss Slanta introduction"
          disabled={updateUser.isPending}
          onClick={() => dismiss()}
        >
          <X />
        </Button>
      </div>
    </section>
  )
}
